module.exports = __webpack_public_path__ + "img/logo-consejeria.fab3ac7c.png";